import { render, staticRenderFns } from "./TriviaIcon.vue?vue&type=template&id=4751ca2c&"
import script from "./TriviaIcon.vue?vue&type=script&lang=js&"
export * from "./TriviaIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports